import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import Sidebar from "../../components/Sidebar";
import { RiArrowDownSLine, RiErrorWarningFill } from "react-icons/ri";
import { BiExport } from "react-icons/bi";
import CryptoOrders from "./CryptoOrders";
import OrderConfrimation from "./OrderConfrimation";
import CryptoConfirmation from "./CryptoConfirmation";
import { useAuth } from "../../context/auth-context";
import CryptoPayoutConfirmation from "../payouts/CryptoConfirmation";
import GiftcardConfirmation from "../payouts/GiftcardConfirmation";
import Payouts from "../payouts/Crypto";
import { API_URL, PROD_LINK, STAGING_LINK } from "../../constant";
import { IS_STAGING } from "../../constant/api";
import GiftcardModal from "./GiftcardModal";
import Confirmation from "./Confirmation";
import axiosInstance from "../../utils/axiosConfig";
import { TailSpin } from "react-loader-spinner";
import { FaArrowCircleRight, FaTimesCircle } from "react-icons/fa";
import ResolveModal from "./ResolveModal";
import ConfirmResolveModal from "./ConfirmResolveModal";
import SuccessModal from "./SuccessModal";
import { getDateRange } from "../../utils/GetDateRange";
import { CSVLink } from "react-csv";
import { formatAmount } from "../../utils/FormatPerson";
import Rewards from "./Rewards";
import OtcHistory from "./OtcHistory";

const Orders = () => {
  const {
    cryptoModal,
    isAuthenticated,
    setUrlStatus,
    urlStatus,
    filter,
    transactionId,
    setTransactionId,
    logout,
  } = useAuth();
  // const [active, setActive] = useState<boolean>(false);
  const [transacion, setTransaction] = useState<number>(1);

  const [currency, setCurrency] = useState<string>("");
  const [status, setStatus] = useState<any | number>();
  const [network, setNetwork] = useState<string>("");
  const [date, setDate] = useState<string>("");
  const [tsxnId, setTsxnId] = useState<string>("");
  const [currencyUSD, setCurrencyUSD] = useState<any | number>();
  const [currencyNGN, setCurrencyNGN] = useState<any | number>();
  const [userId, setUserId] = useState<string>("");
  const [orderModal, setOrderModal] = useState<boolean>(false);
  const [payoutStatus, setPayoutStatus] = useState<boolean>(false);
  const [refetchCount, setRefetchCount] = useState<number>(0);
  const [cryptoConfirmationModal, setCryptoConfirmationModal] =
    useState<boolean>(false);

  const [cryptoRate, setCryptoRate] = useState<any | number>();

  const [currencyPayout, setCurrencyPayout] = useState<string>("");
  const [statusPayout, setStatusPayout] = useState<string>("");
  const [datePayout, setDatePayout] = useState<string>("");
  const [currencyUSDPayout, setCurrencyUSDPayout] = useState<any | number>();
  const [currencyNGNPayout, setCurrencyNGNPayout] = useState<any | number>();
  const [selectedPayoutDetail, setSelectedPayoutDetail] = useState<any | null>(
    null
  );
  const [giftcardPayoutModal, setGiftcardPayoutModal] =
    useState<boolean>(false);

  const [imageURL, setImageURL] = useState<any[]>([]);
  const [orderGiftcardModal, setOrderGiftcardModal] = useState<boolean>(false);
  const [statusGiftcard, setStatusGiftcard] = useState<any | number>();
  const [dateGiftcard, setDateGiftcard] = useState<string>("");
  const [currencyUSDGiftcard, setCurrencyUSDGiftcard] = useState<
    any | number
  >();
  const [currencyNGNGiftcard, setCurrencyNGNGiftcard] = useState<
    any | number
  >();

  const [userIdGiftcard, setUserIdGiftcard] = useState<string>("");
  const [giftcardUser, setGiftcardUser] = useState<any | null>(null);
  const [txnId, setTxnId] = useState<string>("");
  const [cardType, setCardType] = useState<any[]>([]);
  const [confirmed, setConfirmed] = useState<boolean>();
  const [confirmedModal, setConfirmedModal] = useState<boolean>(false);
  const [ecode, setEcode] = useState<string>("");
  const [autoPay, setAutoPay] = useState<string>("");
  const [payLoader, setPayLoader] = useState<boolean>(false);
  const [refetchCounter, setRefetchCounter] = useState<number>(0);
  const [orderss, setOrderss] = useState<any[]>([]);
  const [summaryUsdt, setSummaryUsdt] = useState<any | number>();
  const [summaryNaira, setSummaryNaira] = useState<any | number>();
  const [totalCount, setTotalCount] = useState<any | number>();
  const [walletCount, setWalletCount] = useState<any | number>();
  const [cryptoCount, setCryptoCount] = useState<any | number>();
  const [giftcardCount, setGiftcardCount] = useState<any | number>();
  const [failedCount, setFailedCount] = useState<any | number>();
  const [deexPointCount, setDeexPointCount] = useState<any | number>();
  const [pendingPayoutCount, setPendingPayoutCount] = useState<any | number>();
  const [completedPayoutCount, setCompletedPayoutCount] = useState<
    any | number
  >();
  const [resolveModal, setResolveModal] = useState<boolean>(false);
  const [resolveConfirmModal, setResolveConfirmModal] =
    useState<boolean>(false);
  const [resolveSuccessModal, setResolveSuccessModal] =
    useState<boolean>(false);
  const [refetchCounting, setRefetchCounting] = useState<number>(0);
  const [selectedPayouts, setSelectedPayouts] = useState<string[]>([]);
  const [selectedPayoutAmountById, setSelectedPayoutAmountById] = useState<
    Record<string, number>
  >({});
  const { current } = getDateRange(filter);
  const [newOrders, setNewOrders] = useState<any[]>([]);
  const [newPayout, setNewPayout] = useState<any[]>([]);
  const [summaryOrderUsdt, setSummaryOrderUsdt] = useState<any | number>();
  const [summaryOrderBtc, setSummaryOrderBtc] = useState<any | number>();
  const [newOrdersSummary, setNewOrdersSummary] = useState<any[]>([]);
  const [refetchPayoutCount, setRefetchPayoutCount] = useState<number>(0);
  const [statusFilter, setStatusFilter] = useState<string>("COMPLETED");
  const [showPayoutBreakdownModal, setShowPayoutBreakdownModal] =
    useState<boolean>(false);
  const [orderFilter, setOrderFilter] = useState<"all" | "crypto" | "giftcard">(
    "all"
  );
  const [payoutFilter, setPayoutFilter] = useState<
    "all" | "crypto" | "giftcard"
  >("all");

  // Keeps count visuals resilient even when backend sends strings/nulls.
  const normalizeCount = (
    value: number | string | undefined | null
  ): number => {
    if (typeof value === "number") {
      return value;
    }

    if (typeof value === "string" && value.trim() !== "") {
      const parsed = Number(value);
      return Number.isNaN(parsed) ? 0 : parsed;
    }

    return 0;
  };

  const formatCountValue = (
    value: number | string | undefined | null
  ): string => normalizeCount(value).toLocaleString();

  useEffect(() => {
    setPayLoader(true);
    axiosInstance
      .get(`${API_URL}api/settings`)
      .then((r: any) => {
        setAutoPay(r.data.data.autoPayStatus);

        setPayLoader(false);
      })
      .catch((e: any) => {
        setPayLoader(false);
        console.log(e.response.data.message);
      });
  }, [isAuthenticated, refetchCounter]);

  const handleChange = () => {
    if (autoPay === "inactive") {
      if (!payLoader) {
        setPayLoader(true);
        axiosInstance
          .patch(`${API_URL}api/settings/autopay-status`, {
            status: "active",
          })
          .then((r: any) => {
            setRefetchCounter((prev) => prev + 1);
            setPayLoader(false);
            // .location.reload();
          })
          .catch((e: any) => {
            console.log(e.response.data.message);
          });
      }
    } else {
      if (!payLoader) {
        setPayLoader(true);
        axiosInstance
          .patch(`${API_URL}api/settings/autopay-status`, {
            status: "inactive",
          })
          .then((r: any) => {
            setRefetchCounter((prev) => prev + 1);
            setPayLoader(false);
            // window.location.reload();
          })
          .catch((e: any) => {
            console.log(e.response.data.message);
          });
      }
    }
  };

  useEffect(() => {
    axiosInstance
      .get(
        `${API_URL}${
          filter === ""
            ? `api/payouts${
                statusFilter ? `?status=${statusFilter.toUpperCase()}` : ""
              }`
            : `api/payouts?from=${current.from}&to=${current.to}${
                statusFilter ? `&status=${statusFilter.toUpperCase()}` : ""
              }`
        }`
      )
      .then((r: any) => {
        if (r.data.data.payouts.length >= 1) {
          const summary = r.data.data.summary || {};
          setSummaryUsdt(summary.usdAmount ?? 0);
          setSummaryNaira(summary.amount ?? 0);
          setTotalCount(summary.totalCount ?? 0);
          setCryptoCount(summary.cryptoCount ?? 0);
          setGiftcardCount(summary.giftCardCount ?? 0);
          setWalletCount(summary.walletCount ?? 0);
          setFailedCount(summary.failedPayoutCount ?? 0);
          setDeexPointCount(summary.deexPointCount ?? 0);
          setPendingPayoutCount(summary.pendingPayoutCount ?? 0);
          setCompletedPayoutCount(summary.completedPayoutCount ?? 0);
        } else {
          setSummaryUsdt(0);
          setSummaryNaira(0);
          setTotalCount(0);
          setCryptoCount(0);
          setGiftcardCount(0);
          setWalletCount(0);
          setFailedCount(0);
          setDeexPointCount(0);
          setPendingPayoutCount(0);
          setCompletedPayoutCount(0);
        }
      })
      .catch((e: any) => {
        console.log(e.response.data.message);
        if (
          e.response.status === 401 &&
          e.response.data.message === "Inavlid token. Please login again!"
        ) {
          logout();
        }
      });
  }, [
    isAuthenticated,
    refetchCounting,
    filter,
    current.from,
    current.to,
    logout,
    statusFilter,
  ]);

  useEffect(() => {
    axiosInstance
      .get(`${API_URL}api/transactions/summary`)
      .then((r: any) => {
        // console.log(r.data.data);
        setSummaryOrderUsdt(r.data.data?.totalOrderUSD);
        setSummaryOrderBtc(r.data.data?.totalBTC);
        setNewOrdersSummary(r.data.data?.currencyDistribution);
      })
      .catch((e: any) => {
        console.log(e.response.data.message);
      });
  }, [isAuthenticated]);

  const payoutData = newPayout.map((payout) => ({
    userName: `${payout?.user?.profile?.firstName} ${payout?.user?.profile?.lastName}`,
    assetName: `${payout?.asset?.name}`,
    transactionType: "Sell",
    assetAmountInUSD: `$${payout?.asset?.amountInUSD?.toFixed(2)}`,
    transactionId: `${payout?._id}`,
    transactionDate: (() => {
      const dateString = payout?.createdAt;
      const date = new Date(dateString);

      const day = date.getDate();
      const ordinalSuffix = (day: number) => {
        switch (day) {
          case 1:
          case 21:
          case 31:
            return "st";
          case 2:
          case 22:
            return "nd";
          case 3:
          case 23:
            return "rd";
          default:
            return "th";
        }
      };

      const formattedDate = `${date.toLocaleString("default", {
        month: "short",
      })} ${day}${ordinalSuffix(
        day
      )}, ${date.getFullYear()} | ${date.toLocaleString("default", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      })}`;

      return formattedDate;
    })(),

    transactionStatus: `${payout?.status}`,
  }));

  const orderData = newOrders.map((order) => {
    // Extract asset name based on transaction type

    // Extract asset value based on transaction type

    // Format transaction date
    const formatDate = (dateString: string) => {
      const date = new Date(dateString);
      const day = date.getDate();
      const ordinalSuffix = (day: number) => {
        switch (day) {
          case 1:
          case 21:
          case 31:
            return "st";
          case 2:
          case 22:
            return "nd";
          case 3:
          case 23:
            return "rd";
          default:
            return "th";
        }
      };

      return `${date.toLocaleString("default", {
        month: "short",
      })} ${day}${ordinalSuffix(
        day
      )}, ${date.getFullYear()}, ${date.toLocaleString("default", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      })}`;
    };

    // Determine transaction status
    let status = order.status;
    if (
      order.transactionType === "crypto-deposit" ||
      order.transactionType === "deex-deposits" ||
      (order.transactionType === "deex-crypto-withdrawals" && !order.status)
    ) {
      status = "COMPLETED";
    } else {
      status = order?.status?.toUpperCase();
    }

    let fee = order?.fees;
    if (order?.fees) {
      fee = formatAmount(order?.fees);
    } else {
      fee = "0.00";
    }

    return {
      userName: `${order?.userDetails?.profile?.firstName} ${order?.userDetails?.profile?.lastName}`,
      assetPurchased:
        order.transactionType === "gift-card-transactions"
          ? order?.card?.name
          : order.transactionType === "payouts"
          ? order?.asset?.name
          : order.transactionType === "deex-asset-swaps"
          ? order?.from?.asset
          : order.currency,
      transactionType: order?.transactionType,
      assetPurchasedValue: `${
        order?.transactionType === "gift-card-transactions"
          ? ` $${formatAmount(
              order?.tradeValue?.reduce(
                (total: any, item: { amount: any }) => total + item.amount,
                0
              )
            )}`
          : order?.transactionType === "deex-crypto-withdrawals"
          ? ` ${formatAmount(order?.amount)} ${order?.currency}`
          : order?.transactionType === "payouts"
          ? ` $${formatAmount(order?.asset?.amountInUSD)}`
          : order?.transactionType === "deex-asset-swaps"
          ? ` ${formatAmount(order?.from?.amount)} ${order?.from?.asset} -> ${
              order?.to?.asset
            }`
          : order?.transactionType === "deex-deposits"
          ? ` ${formatAmount(order?.amount)} ${order?.currency?.toUpperCase()}`
          : ` $${formatAmount(order?.usdtAmount)}`
      }`,
      transactionId: order?._id,
      transactionDate: formatDate(order?.createdAt || order?.processedAt),
      transactionStatus: status,
      fee: fee,
    };
  });

  return (
    <div className="w-full h-screen flex flex-col overflow-hidden">
      <div className="w-full h-[31px] shrink-0 bg-[#1B1B1B] flex justify-center items-center">
        {IS_STAGING ? (
          <h4 className="font-medium text-[#AEBCC6] text-[12px]">
            You are in Staging:{" "}
            <span>
              <a href={PROD_LINK} className="text-[#03C668]">
                Switch to Prod
              </a>
            </span>
          </h4>
        ) : (
          <h4 className="font-medium text-[#AEBCC6] text-[12px]">
            You are in PROD:{" "}
            <span>
              <a href={STAGING_LINK} className="text-[#DF4E4E]">
                Switch to Staging
              </a>
            </span>
          </h4>
        )}
      </div>
      <div className="flex flex-1 min-h-0 w-full flex-col lgss:flex-row overflow-hidden">
        <Sidebar />
        <div className="w-full lgss:w-10/12 flex-1 min-h-0 min-w-0 overflow-y-auto bg-[#13181B]">
          <Navbar />
          <div className="w-full px-5 h-full pt-16 mds:px-8 font-manrope lgss:px-10 pb-24 bg-[#13181B]">
            <div className="w-full flex flex-col lgss:flex-row justify-start items-start gap-6">
              <div className="w-full mx-auto md:w-[90%] lgss:mx-0 lgss:w-2/5  rounded-xl bg-[#1C2227] p-4 lgss:p-6">
                <h4 className="text-[10px] xs:text-[12px] font-bold text-[#E7EBEE]">
                  Total Order
                </h4>
                <h4 className="font-sora font-bold text-[24px] text-[#BEE1FB] mt-2">
                  ${summaryOrderUsdt ? formatAmount(summaryOrderUsdt) : 0}
                </h4>
                <h4 className="font-sora font-bold text-[12px]  text-[#869AA9] mt-2">
                  {summaryOrderBtc ? formatAmount(summaryOrderBtc) : 0} BTC
                </h4>
                <div className="w-full mt-8 flex gap-2 justify-center items-center">
                  {[
                    {
                      currency: "USDT",
                      color: "#0D851D",
                      textColor: "#E8F3FC",
                      percentage:
                        newOrdersSummary.find(
                          (item) => item.currency === "USDT"
                        )?.percentage || 0,
                    },
                    {
                      currency: "BTC",
                      color: "#BE6B0A",
                      textColor: "#E8F3FC",
                      percentage:
                        newOrdersSummary.find((item) => item.currency === "BTC")
                          ?.percentage || 0,
                    },
                    {
                      currency: "SOL",
                      color: "#279DF3",
                      textColor: "#E8F3FC",
                      percentage:
                        newOrdersSummary.find((item) => item.currency === "SOL")
                          ?.percentage || 0,
                    },
                    {
                      currency: "ETH",
                      color: "#4E606E",
                      textColor: "#E8F3FC",
                      percentage:
                        newOrdersSummary.find((item) => item.currency === "ETH")
                          ?.percentage || 0,
                    },
                    {
                      currency: "TRX",
                      color: "#D92B2B",
                      textColor: "#E8F3FC",
                      percentage:
                        newOrdersSummary.find((item) => item.currency === "TRX")
                          ?.percentage || 0,
                    },
                    {
                      currency: "SHIB",
                      color: "#FFFFFF",
                      textColor: "#000000",
                      percentage:
                        newOrdersSummary.find(
                          (item) => item.currency === "SHIB"
                        )?.percentage || 0,
                    },
                    {
                      currency: "BNB",
                      color: "#F3BA2F",
                      textColor: "#13181B",
                      percentage:
                        newOrdersSummary.find((item) => item.currency === "BNB")
                          ?.percentage || 0,
                    },
                    {
                      currency: "POL",
                      color: "#6F41D8",
                      textColor: "#E8F3FC",
                      percentage:
                        newOrdersSummary.find(
                          (item) =>
                            item.currency === "POL" || item.currency === "MATIC"
                        )?.percentage || 0,
                    },
                  ].map(({ currency, color, textColor, percentage }) => {
                    const barWidth = `${Math.max(percentage, 1)}%`; // Ensure minimum width
                    return (
                      <div
                        key={currency}
                        style={{ width: barWidth }}
                        className="min-w-[13%]"
                      >
                        <div
                          className="px-2 w-full flex justify-start items-center text-[12px] rounded-[4px] h-[24px] "
                          style={{ backgroundColor: color, color: textColor }}
                        >
                          {percentage.toFixed(1)}%
                        </div>
                        <h4 className="text-[11px] mt-1 text-[#869AA9] text-left">
                          {currency}
                        </h4>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="w-full md:w-[90%] mx-auto lgss:mx-0 lgss:w-2/5">
                <div
                  className={
                    failedCount > 0 && !transactionId
                      ? "w-full   rounded-t-xl bg-[#1C2227] p-4 lgss:p-6"
                      : "w-full   rounded-xl bg-[#1C2227] p-4 lgss:p-6"
                  }
                >
                  <div className="w-full flex flex-col sm:flex-row justify-between items-stretch sm:items-start gap-4">
                    <div className="flex-1 min-w-0">
                      <h4 className="text-[10px] xs:text-[12px] font-bold text-[#E7EBEE]">
                        Total payout
                      </h4>
                      <h4 className="font-sora font-bold text-[24px] text-[#BEE1FB] mt-2">
                        ${summaryUsdt ? formatAmount(summaryUsdt) : 0}
                      </h4>
                      <h4 className="font-sora font-bold text-[12px]  text-[#869AA9] mt-2">
                        ₦{summaryNaira ? formatAmount(summaryNaira) : 0}
                      </h4>
                    </div>
                    <div className="flex-shrink-0 w-full sm:w-auto sm:min-w-[140px] max-w-[160px]">
                      <div className="flex items-center justify-between gap-2 mb-2">
                        <h4 className="text-[10px] xs:text-[12px] font-bold text-[#E7EBEE] shrink-0">
                          Status filter
                        </h4>
                        {statusFilter ? (
                          <button
                            type="button"
                            onClick={() => setStatusFilter("")}
                            className="text-[10px] xs:text-[11px] font-semibold text-[#4FB0FF] hover:text-[#BEE1FB] transition whitespace-nowrap shrink-0"
                          >
                            Reset
                          </button>
                        ) : null}
                      </div>
                      <div className=" relative w-full">
                        <select
                          value={statusFilter ?? ""}
                          onChange={(e) =>
                            setStatusFilter(e.target.value || "")
                          }
                          className="w-full appearance-none  rounded-xl border border-[#2C363E] bg-[#161E25] px-4 py-3 pr-9 text-[12px] font-semibold text-[#E7EBEE] focus:border-[#4FB0FF] focus:outline-none focus:ring-2 focus:ring-[#4FB0FF]/20 transition"
                        >
                          <option
                            value=""
                            style={{
                              backgroundColor: "#161E25",
                              color: "#E7EBEE",
                            }}
                          >
                            All
                          </option>
                          <option
                            value="COMPLETED"
                            style={{
                              backgroundColor: "#161E25",
                              color: "#E7EBEE",
                            }}
                          >
                            Completed
                          </option>
                          <option
                            value="PENDING"
                            style={{
                              backgroundColor: "#161E25",
                              color: "#E7EBEE",
                            }}
                          >
                            Pending
                          </option>
                          <option
                            value="FAILED"
                            style={{
                              backgroundColor: "#161E25",
                              color: "#E7EBEE",
                            }}
                          >
                            Failed
                          </option>
                        </select>
                        <RiArrowDownSLine className="pointer-events-none  right-3 top-1/2 absolute -translate-y-1/2 text-[18px] text-[#869AA9]" />
                      </div>
                    </div>
                  </div>
                  <div className="w-full mt-8 flex gap-2 justify-center items-center">
                    {[
                      { count: cryptoCount, color: "#5EAE68", label: "Crypto" },
                      {
                        count: giftcardCount,
                        color: "#BE6B0A",
                        label: "Giftcard",
                      },
                      { count: walletCount, color: "#869AA9", label: "Wallet" },
                    ].map(({ count, color, label }) => {
                      const percentage = totalCount
                        ? (count / totalCount) * 100
                        : 0;
                      const displayPercentage = percentage.toFixed(1);
                      const barWidth = `${Math.max(percentage, 1)}%`; // Ensure minimum width
                      return (
                        <div
                          key={label}
                          style={{ width: barWidth }}
                          className="min-w-[13%]"
                        >
                          <div
                            className="px-2 w-full flex justify-start items-center text-[12px] rounded-[4px] h-[24px] text-[#E8F3FC]"
                            style={{ backgroundColor: color }}
                          >
                            {displayPercentage}%
                          </div>
                          <h4 className="text-[11px] mt-1 text-[#869AA9] text-left">
                            {label}
                          </h4>
                        </div>
                      );
                    })}
                  </div>
                </div>

                {failedCount > 0 && !transactionId ? (
                  <div className="w-full  rounded-b-xl bg-[#3A4852] px-4 lgss:px-6 py-4">
                    <div className="flex justify-between items-center w-full">
                      <div className="flex justify-start gap-2 items-start">
                        <RiErrorWarningFill className="text-[#DF4E4E] text-[18px]" />
                        <div>
                          <h4 className="font-bold text-[12px] text-[#E7EBEE]">
                            Some payouts failed
                          </h4>
                          <h4 className=" mt-2 text-[12px] text-[#869AA9]">
                            You have {failedCount} payout
                            {failedCount > 1 ? "s" : ""} uncompleted.
                          </h4>
                        </div>
                      </div>
                      <button
                        onClick={() => {
                          setUrlStatus("FAILED");
                          setTransaction(2);
                        }}
                        className="text-white px-4 py-1 rounded-lg text-[12px] bg-secondary_button"
                      >
                        Review
                      </button>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>

            <div className="w-full flex justify-between items-center mt-20">
              <h4 className="text-white font-sora font-semibold text-[12px]">
                Activity
              </h4>
              <div className="flex gap-4 items-center">
                <div className="flex items-center gap-2">
                  {payLoader ? (
                    <TailSpin color="#0B75C2" height={20} width={20} />
                  ) : (
                    <div
                      onClick={handleChange}
                      className={`flex w-8  cursor-pointer h-4   rounded-full transition-all duration-500 ${
                        autoPay === "active"
                          ? "bg-secondary_button"
                          : "bg-gray-600"
                      }`}
                    >
                      <span
                        className={`h-4 w-4   rounded-full transition-all duration-500 bg-gray-100 ${
                          autoPay === "active" ? "ml-4" : ""
                        }`}
                      ></span>
                    </div>
                  )}
                  <h4 className="uppercase font-sora font-semibold text-[#869AA9] text-[10px]">
                    Auto Pay:{" "}
                    <span
                      className={autoPay === "active" ? "text-[#359943]" : ""}
                    >
                      {autoPay === "active" ? " ON" : " OFF"}
                    </span>
                  </h4>
                </div>
                <h4 className="text-[#3A4852]">|</h4>
                {/* check if orderData or payoutData is available */}
                {orderData && payoutData && (
                  <CSVLink
                    data={transacion ? payoutData : orderData}
                    filename={transacion ? "payout-list" : `order-list`}
                    className="flex items-center justify-center  gap-2"
                  >
                    <BiExport className="text-[white]" />
                    <h4 className="uppercase font-sora font-semibold mt-1 text-[#869AA9] text-[10px]">
                      Export
                    </h4>
                  </CSVLink>
                )}
              </div>
            </div>
            <div className="bg-[#0D0D0D] w-full flex justify-between items-stretch pr-4 sm:pr-12 h-[67px] mt-4">
              <div className="min-w-0 flex-1 h-full flex items-stretch overflow-x-auto [-webkit-overflow-scrolling:touch]">
                <button
                  onClick={() => {
                    setUrlStatus("");
                    setTransaction(1);
                  }}
                  className={
                    transacion === 1
                      ? "border-secondary_button h-full shrink-0 px-4 sm:px-6 text-[16px] font-semibold text-secondary_button border-b-2 flex items-center "
                      : " h-full shrink-0 px-4 sm:px-6 text-[14px] text-[#C6D0D7] flex items-center "
                  }
                >
                  Orders
                </button>
                <button
                  onClick={() => setTransaction(2)}
                  className={
                    transacion === 2
                      ? "border-secondary_button h-full shrink-0 px-4 sm:px-6 text-[16px] font-semibold text-secondary_button border-b-2 flex items-center "
                      : " h-full shrink-0 px-4 sm:px-6 text-[14px] text-[#C6D0D7] flex items-center "
                  }
                >
                  Payouts
                </button>
                <button
                  onClick={() => setTransaction(3)}
                  className={
                    transacion === 3
                      ? "border-secondary_button h-full shrink-0 px-4 sm:px-6 text-[16px] font-semibold text-secondary_button border-b-2 flex items-center "
                      : " h-full shrink-0 px-4 sm:px-6 text-[14px] text-[#C6D0D7] flex items-center "
                  }
                >
                  Rewards
                </button>
                <button
                  onClick={() => setTransaction(4)}
                  className={
                    transacion === 4
                      ? "border-secondary_button h-full shrink-0 px-4 sm:px-6 text-[16px] font-semibold text-secondary_button border-b-2 flex items-center "
                      : " h-full shrink-0 px-4 sm:px-6 text-[14px] text-[#C6D0D7] flex items-center "
                  }
                >
                  OTC
                </button>
              </div>
              <div className="flex flex-nowrap items-center justify-end gap-2 shrink-0 h-full pl-2">
                {urlStatus === "FAILED" && (
                  <>
                    <button
                      type="button"
                      onClick={() => {
                        setUrlStatus("");
                        setStatusFilter("COMPLETED");
                      }}
                      className="inline-flex items-center justify-center rounded-xl border border-[#2C363E] bg-[#161E25] px-3 py-2 text-[12px] sm:text-[13px] font-semibold text-[#E7EBEE] transition hover:border-[#869AA9] hover:text-white"
                    >
                      Back to completed
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setTransaction(2);
                        setSelectedPayouts([]);
                        setSelectedPayoutAmountById({});
                        setResolveModal(true);
                      }}
                      className="inline-flex items-center justify-center gap-2 rounded-xl bg-secondary_button px-3 sm:px-4 py-2 text-[12px] sm:text-[14px] font-semibold text-white"
                    >
                      <span>Resolve all</span>
                      <FaArrowCircleRight className="text-[11px] shrink-0" />
                    </button>
                  </>
                )}
                {transacion === 2 && (
                  <button
                    type="button"
                    onClick={() => setShowPayoutBreakdownModal(true)}
                    className="inline-flex items-center gap-2 rounded-full border border-[#27313A] px-3 sm:px-4 py-2 text-[11px] sm:text-[12px] font-semibold text-[#E7EBEE] transition hover:border-[#4FB0FF] hover:text-[#4FB0FF]"
                  >
                    More info
                    <FaArrowCircleRight className="text-[13px] shrink-0" />
                  </button>
                )}
                {transactionId && (
                  <button
                    type="button"
                    aria-label="Clear transaction filter"
                    onClick={() => setTransactionId("")}
                    className="p-0.5"
                  >
                    <FaTimesCircle className="text-secondary_button text-[22px] sm:text-[24px] cursor-pointer" />
                  </button>
                )}
              </div>
            </div>
            {(transacion === 1 || transacion === 2) && (
              <div className="w-full flex justify-start items-center gap-2 px-2 py-2 bg-[#0D0D0D] border-b border-[#1C2227]">
                <span className="text-[#869AA9] text-[12px] font-medium mr-2">
                  {transacion === 1 ? "Orders:" : "Payouts:"}
                </span>
                {(["all", "crypto", "giftcard"] as const).map((key) => {
                  const isOrders = transacion === 1;
                  const current = isOrders ? orderFilter : payoutFilter;
                  const setCurrent = isOrders
                    ? setOrderFilter
                    : setPayoutFilter;
                  const label =
                    key === "all"
                      ? "All"
                      : key === "crypto"
                      ? "Crypto"
                      : "Giftcard";
                  return (
                    <button
                      key={key}
                      onClick={() => setCurrent(key)}
                      className={`px-3 py-1.5 rounded-lg text-[13px] font-medium ${
                        current === key
                          ? "bg-secondary_button text-white"
                          : "bg-[#1C2227] text-[#C6D0D7] hover:bg-[#273037]"
                      }`}
                    >
                      {label}
                    </button>
                  );
                })}
              </div>
            )}
            <div>
              {transacion === 1 ? (
                <CryptoOrders
                  orderFilter={orderFilter}
                  setOrderModal={setOrderModal}
                  setUserId={setUserId}
                  setTsxnId={setTsxnId}
                  setCurrency={setCurrency}
                  setCurrencyUSD={setCurrencyUSD}
                  setCurrencyNGN={setCurrencyNGN}
                  setStatus={setStatus}
                  setPayoutStatus={setPayoutStatus}
                  setNetwork={setNetwork}
                  setDate={setDate}
                  refetchCount={refetchCount}
                  setCryptoRate={setCryptoRate}
                  setOrderGiftcardModal={setOrderGiftcardModal}
                  setImageURL={setImageURL}
                  setStatusGiftcard={setStatusGiftcard}
                  setDateGiftcard={setDateGiftcard}
                  setCurrencyUSDGiftcard={setCurrencyUSDGiftcard}
                  setCurrencyNGNGiftcard={setCurrencyNGNGiftcard}
                  currencyNGNGiftcard={currencyNGNGiftcard}
                  setUserIdGiftcard={setUserIdGiftcard}
                  setGiftcardUser={setGiftcardUser}
                  setTxnId={setTxnId}
                  setCardType={setCardType}
                  setEcode={setEcode}
                  setOrderss={setOrderss}
                  setNewOrders={setNewOrders}
                />
              ) : transacion === 2 ? (
                <Payouts
                  payoutFilter={payoutFilter}
                  setStatus={setStatusPayout}
                  setCurrencyUSD={setCurrencyUSDPayout}
                  setCurrencyNGN={setCurrencyNGNPayout}
                  setCurrency={setCurrencyPayout}
                  setDate={setDatePayout}
                  setGiftcardPayoutModal={setGiftcardPayoutModal}
                  setNewPayout={setNewPayout}
                  setSelectedPayout={setSelectedPayoutDetail}
                  refetchPayoutCount={refetchPayoutCount}
                  statusFilter={statusFilter}
                />
              ) : transacion === 3 ? (
                <Rewards />
              ) : transacion === 4 ? (
                <OtcHistory />
              ) : null}
            </div>
          </div>
        </div>
        {orderModal ? (
          <OrderConfrimation
            currency={currency}
            currencyUSD={currencyUSD}
            currencyNGN={currencyNGN}
            status={status}
            network={network}
            date={date}
            tsxnId={tsxnId}
            userId={userId}
            setOrderModal={setOrderModal}
            payoutStatus={payoutStatus}
            setRefetchCount={setRefetchCount}
            setCryptoConfirmationModal={setCryptoConfirmationModal}
            cryptoRate={cryptoRate}
            orderss={orderss}
          />
        ) : null}
        {cryptoConfirmationModal && (
          <CryptoConfirmation
            setOrderModal={setOrderModal}
            tsxnId={tsxnId}
            setRefetchCount={setRefetchCount}
            setCryptoConfirmationModal={setCryptoConfirmationModal}
            currency={currency}
            currencyUSD={currencyUSD}
            currencyNGN={currencyNGN}
            userId={userId}
          />
        )}
        {cryptoModal ? (
          <CryptoPayoutConfirmation
            currency={currencyPayout}
            currencyUSD={currencyUSDPayout}
            currencyNGN={currencyNGNPayout}
            status={statusPayout}
            date={datePayout}
            payout={selectedPayoutDetail}
          />
        ) : null}
        {giftcardPayoutModal ? (
          <GiftcardConfirmation
            currency={currencyPayout}
            currencyUSD={currencyUSDPayout}
            currencyNGN={currencyNGNPayout}
            status={statusPayout}
            date={datePayout}
            setGiftcardModal={setGiftcardPayoutModal}
          />
        ) : null}

        {orderGiftcardModal ? (
          <GiftcardModal
            setOrderModal={setOrderGiftcardModal}
            userId={userIdGiftcard}
            user={giftcardUser}
            currencyUSD={currencyUSDGiftcard}
            currencyNGN={currencyNGNGiftcard}
            status={statusGiftcard}
            imageURL={imageURL}
            cardType={cardType}
            date={dateGiftcard}
            txnId={txnId}
            confirmed={confirmed}
            setConfirmed={setConfirmed}
            ecode={ecode}
            setConfirmedModal={setConfirmedModal}
          />
        ) : null}
        {confirmedModal && (
          <Confirmation
            setConfirmedModal={setConfirmedModal}
            setOrderModal={setOrderGiftcardModal}
            txnId={txnId}
            userId={userIdGiftcard}
            currencyUSD={currencyUSDGiftcard}
            currencyNGN={currencyNGNGiftcard}
            cardType={cardType}
            setConfirmed={setConfirmed}
            setRefetchCount={setRefetchCount}
          />
        )}
        {resolveModal && (
          <ResolveModal
            setResolveModal={setResolveModal}
            setResolveConfirmModal={setResolveConfirmModal}
            selectedPayouts={selectedPayouts}
            setSelectedPayouts={setSelectedPayouts}
            selectedPayoutAmountById={selectedPayoutAmountById}
            setSelectedPayoutAmountById={setSelectedPayoutAmountById}
            setRefetchPayoutCount={setRefetchPayoutCount}
          />
        )}
        {resolveConfirmModal && (
          <ConfirmResolveModal
            setResolveConfirmModal={setResolveConfirmModal}
            setResolveSuccessModal={setResolveSuccessModal}
            selectedPayouts={selectedPayouts}
            onResolved={() => {
              setSelectedPayouts([]);
              setSelectedPayoutAmountById({});
            }}
          />
        )}
        {resolveSuccessModal && (
          <SuccessModal
            setResolveSuccessModal={setResolveSuccessModal}
            setRefetchCounting={setRefetchCounting}
          />
        )}
        {showPayoutBreakdownModal && (
          <div className="fixed inset-0 z-[120] flex items-center justify-center bg-[#05090d]/70 backdrop-blur-sm px-4">
            <div className="w-full max-w-4xl rounded-[28px] border border-[#1F2A32] bg-[#0C1116] p-6 shadow-[0_40px_120px_rgba(2,6,12,0.8)]">
              <div className="flex items-start justify-between gap-4">
                <div>
                  <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-[#4FB0FF]">
                    Breakdown
                  </p>
                  <h3 className="mt-1 text-[24px] font-bold text-white">
                    Payout distribution
                  </h3>
                  <p className="text-[13px] text-[#6F7D89]">
                    Snapshot of every payout channel for the selected window.
                  </p>
                </div>
                <div className="w-full flex justify-end gap-2 items-center">
                  <div className="w-full max-w-[140px]">
                    <div className="relative w-full">
                      <select
                        value={statusFilter ?? ""}
                        onChange={(e) => setStatusFilter(e.target.value || "")}
                        className="w-full appearance-none rounded-xl border border-[#2C363E] bg-[#161E25] px-4 py-3 pr-9 text-[12px] font-semibold text-[#E7EBEE] focus:border-[#4FB0FF] focus:outline-none focus:ring-2 focus:ring-[#4FB0FF]/20 transition"
                      >
                        <option
                          value=""
                          style={{
                            backgroundColor: "#161E25",
                            color: "#E7EBEE",
                          }}
                        >
                          All
                        </option>
                        <option
                          value="COMPLETED"
                          style={{
                            backgroundColor: "#161E25",
                            color: "#E7EBEE",
                          }}
                        >
                          Completed
                        </option>
                        <option
                          value="PENDING"
                          style={{
                            backgroundColor: "#161E25",
                            color: "#E7EBEE",
                          }}
                        >
                          Pending
                        </option>
                        <option
                          value="FAILED"
                          style={{
                            backgroundColor: "#161E25",
                            color: "#E7EBEE",
                          }}
                        >
                          Failed
                        </option>
                      </select>
                      <RiArrowDownSLine className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-[18px] text-[#869AA9]" />
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={() => setShowPayoutBreakdownModal(false)}
                    className="rounded-full border border-[#27313A] px-4 py-2 text-[12px] font-semibold text-[#E7EBEE] hover:border-[#4FB0FF] hover:text-[#4FB0FF]"
                  >
                    Close
                  </button>
                </div>
              </div>
              <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {[
                  {
                    label: "Total payouts",
                    value: totalCount,
                    caption: "Across every payout method",
                    accent: "#4FB0FF",
                  },
                  {
                    label: "Completed payouts",
                    value: completedPayoutCount,
                    caption: "Fully settled",
                    accent: "#5CD198",
                  },
                  {
                    label: "Pending payouts",
                    value: pendingPayoutCount,
                    caption: "In progress",
                    accent: "#F6C343",
                  },
                  {
                    label: "Crypto payouts",
                    value: cryptoCount,
                    caption: "Blockchain settlements",
                    accent: "#5EAE68",
                  },
                  {
                    label: "Giftcard payouts",
                    value: giftcardCount,
                    caption: "Card redemptions",
                    accent: "#BE6B0A",
                  },
                  {
                    label: "Wallet payouts",
                    value: walletCount,
                    caption: "Fiat wallet releases",
                    accent: "#869AA9",
                  },
                  {
                    label: "Failed payouts",
                    value: failedCount,
                    caption: "Requires attention",
                    accent: "#DF4E4E",
                  },
                  {
                    label: "Deex points",
                    value: deexPointCount,
                    caption: "Loyalty rewards issued",
                    accent: "#A07CFF",
                  },
                ].map(({ label, value, caption, accent }) => {
                  const safeValue = normalizeCount(value);
                  const totalValue = normalizeCount(totalCount);
                  const ratio =
                    label === "Total payouts"
                      ? 100
                      : totalValue
                      ? Math.min((safeValue / totalValue) * 100, 100)
                      : 0;

                  return (
                    <div
                      key={label}
                      className="rounded-2xl border border-[#1F2A32] bg-gradient-to-br from-[#0D1115] to-[#151C23] p-5 shadow-[0_25px_60px_rgba(3,7,14,0.65)]"
                    >
                      <div className="flex items-center justify-between gap-4">
                        <div>
                          <p className="text-[11px] font-semibold uppercase tracking-[0.08em] text-[#6F7D89]">
                            {label}
                          </p>
                          <p className="mt-1 text-[24px] font-bold text-[#E7EBEE]">
                            {formatCountValue(safeValue)}
                          </p>
                        </div>
                        <span
                          className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-[#1B252D]"
                          style={{
                            boxShadow: `0 0 25px ${accent}40`,
                            color: accent,
                          }}
                        >
                          ●
                        </span>
                      </div>
                      <p className="mt-3 text-[12px] text-[#617889]">
                        {caption}
                      </p>
                      <div className="mt-4 h-[6px] w-full rounded-full bg-[#1F2A32]">
                        <div
                          className="h-full rounded-full transition-all duration-500"
                          style={{
                            width: `${ratio}%`,
                            backgroundImage: `linear-gradient(90deg, ${accent}, ${accent})`,
                          }}
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Orders;
